const initialState = {
    loading: false,
    data: [],
    error: null,
};

const matchesReducer = (state = initialState, action) => {
    switch (action.type) {
        case "MATCHES_PENDING":
            return {
                ...state,
                loading: true,
                error: null,
            };
        case "MATCHES_SUCCESS":
            return {
                ...state,
                data: action.payload,
                loading: false,
                error: null,
            };
        case "MATCHES_ERROR":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case "MATCH_SUBMIT":
            return {
                ...state,
                data: state.data.map((match) => {
                    if (action.payload?.ids?.includes(match.id)) {
                        return {
                            ...match,
                            scheduleDate: action.payload.startDate,
                        };
                    } else if (match.id !== action.payload.id) {
                        return match;
                    } else {
                        return action.payload;
                    }
                }),
            };
        default:
            return state;
    }
};

export default matchesReducer;
